import { OnInit, Input, Output, EventEmitter, Component, NgZone, ChangeDetectorRef,
         ApplicationRef, ViewChild, ElementRef} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/observable/fromEvent';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'vq-autocomplete',
  templateUrl: './form-autocomplete.component.html',
})
export class FormAutocompleteComponent implements OnInit {
  // inspired by
  // https://stackoverflow.com/questions/32051273/angular-and-debounce

  @ViewChild('input') inputElRef: ElementRef;

  @Input('vqDisabled') disabled:boolean = false;
  @Input('vqModel') model:any;
  @Input('vqLabel') label:string;
  @Input('vqEndpoint') endpoint:string;
  @Input('vqFilterKey') filterKey:string;
  @Input('vqFilter') filter:any = {};
  @Input('vqPlaceholder') placeholder:string;
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;
  @Input('vqLabelGetter') labelGetter:any = this._defaultLabelGetter;
  @Input('vqValueGetter') valueGetter:any = this._defaultValueGetter;
  @Input('vqOptions') values:Array<string> = [];
  @Input('vqValue') value:any = '';
  @Input('vqEmbed') embed:boolean = false;
  @Input('vqClassList') classlist:Array<string> = [];

  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();

  filtered:Array<any>
  term = new FormControl();
  items: Observable<any>;
  focused : boolean = false;
  tabIndex : number = 0;

  id:string;

  constructor(
    private ngzone: NgZone,
    private _cdref: ChangeDetectorRef,
    private _api: ApiService) {}

  private setVqId() {
  	this.id = Math.random().toString(36).substr(2, 8);
  }

  private _defaultLabelGetter(o:any):any {
    return o;
  }

  private _defaultValueGetter(o:any):any {
    return o;
  }

  private _filter(term) {
    if (this.endpoint) {
      let q = Object.assign({}, this.filter);
      q[this.filterKey] = term;
      this._api[this.endpoint].list(q).subscribe((v) => {
        this.filtered = v.results;
        this._cdref.detectChanges();
      })
    } else {
      this.filtered = this.values.filter((v) => {
        return (this.getLabel(v).toLowerCase().indexOf(term.toLowerCase()) > -1)
      })
      this._cdref.detectChanges();
    }

    // console.log(this.filtered);
  }

  public hasError() {
    return (this.errors && this.errors.length > 0);
  }

  private _resolveValue(obj:any, attr:string):any {
    return attr.split('.').reduce(function(prev, curr) {
        // return prev[curr] ? prev[curr] : prev;
        return prev[curr];
    }, obj)
  }

  private _isString(v) {
    return typeof v === 'string';
  }

  public getLabel(a) {
    if (this._isString(this.labelGetter)) {
      return this._resolveValue(a, this.labelGetter);
    } else {
      return this.labelGetter(a);
    }
  }

  public getValue(a) {
    if (this._isString(this.valueGetter)) {
      return this._resolveValue(a, this.valueGetter);
    } else {
      return this.valueGetter(a);
    }
  }

  select(v) {
    this.ngzone.run(() => {
      this.model = this.getValue(v);
      this.value = '';
      setTimeout(() => {
        this.value = this.getLabel(v);
      }, 10)
      this.modelChange.emit(this.getValue(v));
      // this._filter(this.model);
      this.filtered = [];
      // this._cdref.detectChanges();
    });
  }

  onBlur() {
    this.focused = false;
    this.tabIndex = 0;
  }

  onFocus() {
    this.focused = true;
  }

  ngOnInit() {
  	this.setVqId();
    this.filtered = this.values;
  }

  ngAfterViewInit() {
    // this.ngzone.runOutsideAngular( () => {
      Observable.fromEvent(this.inputElRef.nativeElement, 'focus')
        // .debounceTime(200)
        .subscribe((keyboardEvent:any) => {
          let keycode = keyboardEvent.keyCode;

          if (keycode != 40 && keycode != 38 && keycode != 13) {
            this.tabIndex = 0;
            let term = keyboardEvent.target.value;
            this._filter(term);
          }
        })

      Observable.fromEvent(this.inputElRef.nativeElement, 'keyup')
        .debounceTime(200)
        .subscribe((keyboardEvent:any) => {
          let keycode = keyboardEvent.keyCode;

          if (keycode != 40 && keycode != 38 && keycode != 13) {
            this.tabIndex = 0;
            let term = keyboardEvent.target.value;
            this._filter(term);
          }
        })

      Observable.fromEvent(this.inputElRef.nativeElement, 'keydown')
        .subscribe((keyboardEvent:any) => {
          let keycode = keyboardEvent.keyCode;

          if (keycode == 40 && this.tabIndex < this.filtered.length - 1) {
            this.tabIndex++;
          } else if (keycode == 38 && this.tabIndex > 0) {
            this.tabIndex--;
          } else if (keycode == 13) {
            this.select(this.filtered[this.tabIndex]);
            this.inputElRef.nativeElement.blur();
          }
        })
    // })
  }
}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-autocomplete/form-autocomplete.component.ts